import { api, API } from "@/lib/api";

// ---- Admin payment-settings ----
export const adminGetPaymentSettings = () =>
  api.get(`/admin/payment-settings`).then((r) => r.data);

export const adminUpdatePaymentSettings = (patch) =>
  api.put(`/admin/payment-settings`, patch).then((r) => r.data);

export const adminTestPaymentConnection = (provider) =>
  api
    .post(`/admin/payment-settings/test`, { provider })
    .then((r) => r.data);

export const adminListPayments = (params) =>
  api.get(`/admin/payments`, { params }).then((r) => r.data);

// ---- Student ----
export const getPlanPreview = (enrollmentId, plan, currency) =>
  api
    .get(`/student/enrollments/${enrollmentId}/payment-plan-preview`, {
      params: { plan, currency },
    })
    .then((r) => r.data);

export const startCheckout = (enrollmentId, body) =>
  api
    .post(`/student/enrollments/${enrollmentId}/checkout`, body)
    .then((r) => r.data);

export const confirmRazorpay = (paymentId, body) =>
  api.post(`/payments/${paymentId}/confirm`, body).then((r) => r.data);

export const myPayments = () =>
  api.get(`/student/payments`).then((r) => r.data);

// ---- Brochure ----
export const brochurePdfUrl = (courseId) =>
  `${API}/courses/${courseId}/brochure.pdf`;

/**
 * Open the brochure PDF in a new tab. Uses fetch+blob so we can pass the
 * Authorization header (the endpoint requires login).
 */
export async function openBrochurePdf(courseId, fallbackName = "brochure.pdf") {
  const token = localStorage.getItem("kks_access_token");
  const resp = await fetch(brochurePdfUrl(courseId), {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(txt || `HTTP ${resp.status}`);
  }
  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank");
  if (!w) {
    const a = document.createElement("a");
    a.href = url;
    a.download = fallbackName;
    a.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

// ---- Razorpay JS loader ----
let _rzpLoading = null;
export function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve(true);
  if (_rzpLoading) return _rzpLoading;
  _rzpLoading = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("Failed to load Razorpay"));
    document.head.appendChild(s);
  });
  return _rzpLoading;
}

export const CURRENCY_SYMBOL = { INR: "₹", USD: "$" };

export function formatMoney(amount, ccy) {
  const sym = CURRENCY_SYMBOL[ccy] || "";
  const n = Number(amount || 0);
  return `${sym}${n.toLocaleString(undefined, {
    maximumFractionDigits: 2,
    minimumFractionDigits: ccy === "USD" ? 2 : 0,
  })}`;
}
